// POST the manifest to GitHub via a hidden form (browser-initiated so the
// customer's GitHub session authorizes App creation).
export const submitManifestToGitHub = (
  formAction: string,
  manifestJson: string
): void => {
  const form = document.createElement("form")
  form.method = "post"
  form.action = formAction

  const input = document.createElement("input")
  input.type = "hidden"
  input.name = "manifest"
  input.value = manifestJson
  form.appendChild(input)

  document.body.appendChild(form)
  form.submit()
  form.remove()
}
